import { useTranslation } from "react-i18next";
import { SectionTitle } from "../../components/SettingsComponents/SectionTitle";
import { NotificationPreferencesContent } from "../../components/PreferencesComponents/NotificationPreferencesContent";

export const NotificationPreferences = () => {
  const { t } = useTranslation(["Preferences"]);

  return (
    <>
      <SectionTitle title={t("NotificationPreferences.Header")} />
      <div className="et-system-preferences module-layout-content h-100 et-board-list-scrollable-container">
        <div className="m-4 system-preferences-content">
          <div className="mt-4">
            <NotificationPreferencesContent />
          </div>
        </div>
      </div>
    </>
  );
};
